import { useState } from "react";
import { AlertTriangle, CheckCircle2, Download, Puzzle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HelperInstallDialog } from "@/components/HelperBar";
import HelperChangelog from "@/components/HelperChangelog";
import { HELPER_LATEST_VERSION, HELPER_ZIP, helperVersion, versionAtLeast } from "@/lib/helper";

function Status({ version, upToDate }) {
  if (!version) return <span className="text-sm text-muted-foreground" data-testid="settings-helper-status">Belum dipasang di browser ini</span>;
  if (upToDate) return <span className="flex items-center gap-2 text-sm text-emerald-300" data-testid="settings-helper-status"><CheckCircle2 className="h-4 w-4" /> Terpasang v{version} — versi terkini</span>;
  return <span className="flex items-center gap-2 text-sm text-amber-200" data-testid="settings-helper-status"><AlertTriangle className="h-4 w-4" /> Terpasang v{version} — kemas kini tersedia</span>;
}

export default function HelperSettingsSection() {
  const [open, setOpen] = useState(false);
  const version = helperVersion();
  const upToDate = !!version && versionAtLeast(version, HELPER_LATEST_VERSION);
  return (
    <section className="panel fade-up p-6" data-testid="settings-helper-section">
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/15 text-primary"><Puzzle className="h-4 w-4" /></div>
        <div>
          <h2 className="font-bold">PostPintar Helper (Chrome extension)</h2>
          <p className="mt-1 text-sm text-muted-foreground">Muat turun versi terbaharu Helper untuk isi teks & gambar automatik dalam "Cipta siaran" group Facebook.</p>
        </div>
      </div>
      <div className="mt-6 space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-border p-4">
          <div>
            <p className="text-sm font-medium">Versi terbaharu: <span className="font-mono text-primary" data-testid="settings-helper-latest-version">v{HELPER_LATEST_VERSION}</span></p>
            <div className="mt-1"><Status version={version} upToDate={upToDate} /></div>
          </div>
          <Button asChild data-testid="settings-helper-download-btn">
            <a href={`${HELPER_ZIP}?v=${HELPER_LATEST_VERSION}`} download="postpintar-helper.zip"><Download className="mr-2 h-4 w-4" /> Muat turun v{HELPER_LATEST_VERSION}</a>
          </Button>
        </div>
        <p className="text-xs leading-relaxed text-muted-foreground">
          Kemas kini: extract zip dan ganti folder <b className="text-slate-200">postpintar-helper</b> lama, kemudian tekan ikon muat semula (reload) pada Helper di <code className="text-slate-200">chrome://extensions</code> dan F5 halaman ini.
        </p>
        <Button variant="secondary" onClick={() => setOpen(true)} data-testid="settings-helper-guide-btn">Cara pasang</Button>
        <div>
          <p className="eyebrow mb-1">Apa yang baharu</p>
          <HelperChangelog />
        </div>
        <HelperInstallDialog open={open} onOpenChange={setOpen} />
      </div>
    </section>
  );
}
